import { useTranslation } from 'react-i18next'

import {
  ArrowRightCircleIcon,
  AssociatedDeviceIcon,
  Box as DarkBox,
  GridEnabledIcon,
  StatusPill,
} from '@hivewatch/dark'

import { ConnectionI } from '../../types/types'
import { darkAssociateModalStyles } from './DarkAssociateDeviceModal.styles'

interface DarkAssociationStatusPillsIProps {
  colorScheme: 'dark' | 'light'
  connection: ConnectionI
}

/**
 * The canonical association-status vocabulary from the ENG-32182 design:
 * Associated → Grids Drawn → Tailgating Enabled, each an additive step. A
 * pair that is only geometrically eligible ("Ready to Associate") shows no
 * pill until it is actually associated.
 */
export const DarkAssociationStatusPills = ({
  colorScheme,
  connection,
}: DarkAssociationStatusPillsIProps) => {
  const { t } = useTranslation()
  const s = darkAssociateModalStyles(colorScheme)
  const { isConnected, isTailgateGridConfigured, isTailgateEnabled } =
    connection || {}

  if (!isConnected) return null

  return (
    <DarkBox
      {...s.statusRow}
      data-testid='DarkAssociateDeviceModal:statusPills'
    >
      <StatusPill
        colorScheme={colorScheme}
        icon={<AssociatedDeviceIcon />}
        label={t('floors:tailgate_status_associated')}
        variant='teal'
      />
      {isTailgateGridConfigured && (
        <StatusPill
          colorScheme={colorScheme}
          icon={<GridEnabledIcon />}
          label={t('floors:tailgate_status_grids_drawn')}
          variant='teal-blue'
        />
      )}
      {isTailgateEnabled && (
        <StatusPill
          colorScheme={colorScheme}
          icon={<ArrowRightCircleIcon />}
          label={t('floors:tailgate_status_tailgating_enabled')}
          variant='teal-green'
        />
      )}
    </DarkBox>
  )
}
